module.exports = __webpack_public_path__ + "assets/img/logoEn.ac25a5c3.png";